import { i18n } from '@senderra/translations';

export default i18n;
